import { useQuery } from "@tanstack/react-query";
import { getLeadTrackStatuses } from "../api";

export const LEAD_TRACK_STATUSES_QUERY_KEY = "leadTrackStatuses";

interface UseLeadTrackStatusesOptions {
  leadTrackUId: string;
  search?: string;
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

export const useLeadTrackStatuses = ({
  leadTrackUId,
  search,
  page = 1,
  pageSize = 50,
  enabled = true,
}: UseLeadTrackStatusesOptions) => {
  return useQuery({
    queryKey: [LEAD_TRACK_STATUSES_QUERY_KEY, leadTrackUId, search, page, pageSize],
    queryFn: async () => {
      const response = await getLeadTrackStatuses({
        leadTrackUId,
        search,
        page,
        pageSize,
      });
      return response.data;
    },
    enabled: enabled && !!leadTrackUId,
    staleTime: 30000, // 30 seconds
  });
};

export default useLeadTrackStatuses;

